(function () {
    'use strict';

    function requestForProposalResponseController($scope, rfpResponseData, requestForProposalResponseStateService) {
        var vm = this;
        vm.rfpResponseId = rfpResponseData.Id.split('/')[1];
        vm.rfpResponseData = rfpResponseData;

        vm.tabs = {
            'rfpResponse.rfpSummary': {
                header: 'RFP Summary',
                active: true,
                additionalStates: []
            },
            'rfpResponse.responseEditor': {
                header: 'RFP Response',
                active: false,
                additionalStates: []
            }
        };

        $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            vm.changeTab(toState.name);
            $('html,body').scrollTop(0);
        });

        $scope.$on('rfpResponsUpdated', function () {
            vm.rfpResponseData = requestForProposalResponseStateService.get();
        });

        vm.changeTab = function (tabName) {
            for (var property in vm.tabs) {
                if (vm.tabs.hasOwnProperty(property)) {
                    vm.tabs[property].active = property === tabName || (
                        vm.tabs[property].additionalStates &&
                            vm.tabs[property].additionalStates.indexOf(tabName) !== -1);
                }
            }
        }
    }

    requestForProposalResponseController.$inject = ['$scope', 'rfpResponseData', 'requestForProposalResponseStateService'];

    angular.module('ecap.requestForProposal').controller('requestForProposalResponseController', requestForProposalResponseController);
})();
